import { useModal } from "../ModalContext";
import { useNavigate } from "react-router-dom";

function UserModal() {
  const { userModal, setUserModal, setPostModal } = useModal();
  const navigate = useNavigate();
  const username = localStorage.getItem("user");

  if (!userModal) return null;

  return (
    <div
      style={styles.overlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          setUserModal(null);
        }
      }}
    >
        {/* ❌ закрыть */}
        <button
            onClick={() => setUserModal(null)}
            style={styles.closeBtn}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.1)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(0,0,0,0.4)";
            }}
            >
            ✕
            </button>

      <div style={styles.modal}>

        {/* ЛЕВАЯ ЧАСТЬ */}
        <div style={styles.userLeft}>
          <img
            src={userModal.avatar || "https://via.placeholder.com/100"}
            style={styles.userAvatarBig}
          />

          <h3 style={{ marginBottom: 2 }}>
            {userModal.name || "Без имени"}
            </h3>

            <p style={{ opacity: 0.6, marginTop: 0 }}>
            @{userModal.username}
            </p>

            {(userModal.contacts || []).includes(username) && (
            <div style={styles.friendBadge}>
                уже в контактах
            </div>
            )}

          <div style={styles.status}>
            {userModal.status || "без статуса"}
          </div>
        </div>

        {/* ПРАВАЯ ЧАСТЬ */}
        <div style={styles.userRight}>

        {/* 📄 описание */}
        <div style={styles.userBioBox}>
            {userModal.bio || "Нет информации"}
        </div>

        {/* 🧩 посты сразу после описания */}
        <div style={styles.userPostsRow}>
            {(userModal.posts || []).slice(0, 6).map((p, i) => (
            <img
                key={i}
                src={p.image}
                style={styles.userPostPreview}
            />
            ))}
        </div>

        {/* 🔘 кнопка внизу */}
        <button
            style={styles.goProfileBtn}
            onClick={() => {
            setUserModal(null);   // закрываем профиль
            setPostModal(null);   // 🔥 закрываем пост
            navigate(`/user/${userModal.username}`);
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.15)";
                e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.08)";
                e.currentTarget.style.transform = "translateY(0)";
            }}
            onMouseDown={(e) => {
                e.currentTarget.style.transform = "scale(0.97)";
            }}
            onMouseUp={(e) => {
                e.currentTarget.style.transform = "scale(1)";
            }}
            >
            Перейти в профиль
            </button>

        </div>

      </div>
    </div>
  );
}

const styles = {
overlay: {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.5)",
  backdropFilter: "blur(8px)",

  display: "flex",
  alignItems: "center",     // ✅ центр по вертикали
  justifyContent: "center", // ✅ центр по горизонтали

    zIndex: 99999 // 🔥 ВАЖНО
},

modal: {
  width: "90%",
  maxWidth: 500,
  maxHeight: "90vh", // ✅ не во весь экран

  background: "#1e1e1e",
  padding: 20,
  borderRadius: 16,
  color: "#fff",
  display: "flex",
  gap: 20,
  position: "relative",
  transform: "scale(0.95)",
  animation: "zoomIn 0.2s ease forwards"
},

  userLeft: {
    width: 150,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center"
  },

  userRight: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },

  userAvatarBig: {
    width: 90,
    height: 90,
    borderRadius: "50%",
    marginBottom: 10
  },

  friendBadge: {
    marginTop: 8,
    fontSize: 12,
    color: "#4caf50"
  },

  status: {
    marginTop: 10,
    padding: "6px 12px",
    borderRadius: 12,

    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.2)",
    backdropFilter: "blur(10px)",

    fontSize: 13,
    color: "#ddd"
    },

  userBioBox: {
    background: "#2a2a2a",
    padding: 10,
    borderRadius: 10
  },

  userPostsRow: {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 8,
  marginTop: 15
},

  userPostPreview: {
  width: "100%",
  aspectRatio: "1/1",
  objectFit: "cover",
  borderRadius: 8,
  cursor: "default"
},

  goProfileBtn: {
  marginTop: 15,
  padding: "12px",

  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.15)",

  background: "rgba(255,255,255,0.08)",
  backdropFilter: "blur(8px)",

  color: "#fff",
  fontWeight: "500",
  fontSize: 14,

  cursor: "pointer",
  transition: "all 0.2s ease"
},

 closeBtn: {
  position: "fixed",   // 🔥 ключевой момент
  top: 20,
  right: 20,

  width: 36,
  height: 36,

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  background: "rgba(0,0,0,0.4)",
  border: "1px solid rgba(255,255,255,0.15)",
  backdropFilter: "blur(8px)",

  borderRadius: 10,
  color: "#fff",
  fontSize: 18,
  cursor: "pointer",

  zIndex: 3000, // 👈 чтобы всегда была сверху
  transition: "all 0.2s ease"
},

  friendBadge: {
  marginTop: 4,
  fontSize: 12,
  color: "#4caf50"
},
};

export default UserModal;